import type { TFunc } from '@/translations/hooks';

export const templateStatusLabel = (status: string, t: TFunc): string => {
  switch (status) {
    case 'Draft':
      return t('jobChainTemplatesStatusDraft');
    case 'Active':
      return t('jobChainTemplatesStatusActive');
    case 'Inactive':
      return t('jobChainTemplatesStatusInactive');
    default:
      return status;
  }
};

export const templateScopeLabel = (scope: string, t: TFunc): string => {
  switch (scope) {
    case 'Global':
      return t('jobChainTemplatesScopeGlobal');
    case 'Customer':
      return t('jobChainTemplatesScopeCustomer');
    default:
      return scope;
  }
};
